import { AppVersion, GenericState } from '@/types';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { customStorage } from './utils';
import { create } from 'zustand';
import Config from '@/config';
import { Nullable, User, UserWithToken } from '@ygoargentina/sdk/api/api.types';

export type UserState = GenericState & {
  user: Nullable<UserWithToken>;
  users: User[];

  setUser: (user: Nullable<UserWithToken | User>) => void;
  setUsers: (user: User[]) => void;
};

export const usersInitialState = {
  user: null,
  users: [],
};

export const useUserStore = create<
  UserState,
  [['zustand/devtools', never], ['zustand/persist', UserState]]
>(
  devtools(
    persist(
      (set) => ({
        ...usersInitialState,

        setUser: (user: Nullable<UserWithToken | User>) =>
          set((state) => ({
            ...state,
            user: user ? { ...state.user, ...user } as UserWithToken : null,
          })),
        setUsers: (users: User[]) => set((state) => ({ ...state, users })),
        resetStore: () => set(() => usersInitialState),
      }),
      {
        name: `${Config.sessionKey}-users@${AppVersion}`,
        storage: createJSONStorage(() => customStorage),
      }
    )
  )
);
